import { SYSTEM_BREADCRUMB_GETTER_GET_LIST } from '@/store/modules/system/breadcrumb/systemBreadcrumb.constant'

export default {
  [SYSTEM_BREADCRUMB_GETTER_GET_LIST] (state) {
    return state.list.filter(item => item)
  }
}
